import React, { Component } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { ReactComponent as IconHead2 } from "../../../assets/icon/icon-head-2.svg"
import { message, Select, Radio, Popover, Spin, Checkbox } from 'antd'
import { statisticCutoff, getStatisticCutoff, exportCutoffV2 } from "../../../services/api/apiOrdersReport"
import StaticsTableCutoff from "./StaticsTableCutoff"
import { runExportJob, isExporting, subscribeExporting } from '../../helpers/runExportJob'
import moment from 'moment'
import {
    parseQueryString,
    updateWindowLocation
} from '../../helpers/windowURI'
const EXPORT_KEY = 'statics-cutoff:export'

class StaticsCutoffPage extends Component {
    timeout = 0
    state = {
        loading: false,
        error: '',
        selectedDate: '',
        cutoffDate: '',
        data: [],
        exporting: isExporting(EXPORT_KEY),
        partner: '',
        listTab: [],
        currentTab: localStorage.getItem('cutoff_current_tab') || '', // ['', cutoff_noel, cutoff_new_year]
        summary: {},
        embroideryFilter: false,
        allowedTypes: [],
        silkFilter: false,
        sortData: {
            sort: 'total',
            desc: true
        },
    }

    componentDidMount() {
        // `exporting` DERIVE từ khoá in-flight cấp module thay vì state riêng.
        // Khoá sống theo tab, state sống theo instance: component unmount khi đổi route mà request
        // có thể bay tới 60s (EXPORT_JOB_TIMEOUT), nên state riêng làm nút trông sẵn sàng dù khoá
        // còn giữ. Derive cũng loại luôn `setState` sau unmount.
        this._unsubscribeExporting = subscribeExporting(() => {
            this.setState({ exporting: isExporting(EXPORT_KEY) })
        })
        this.setState({ exporting: isExporting(EXPORT_KEY) })

        // this._fetchStaticsCreated()
        const data = parseQueryString(window.location.href, {
            cutoff_type: 'currentTab'
        })

        this.setState(data, this._fetchStatisticCutoff)
    }

    componentWillUnmount() {
        if (this._unsubscribeExporting) this._unsubscribeExporting()
    }

    _fetchStatisticCutoff = async () => {
        const { partner, order_type, currentTab } = this.state
        this.setState({
            loading: true,
            error: '',
            data: [],
            summary: {}
        })
        try {
            const payload = {
                ...(partner && { partner }),
                ...(order_type && { order_type }),
                return_orders: true
            }

            if (currentTab) payload.cutoff_type = currentTab

            updateWindowLocation(payload)

            const { data: res } = await getStatisticCutoff(payload)
            const { success, data, message: mess } = { ...res }
            const { show_tabs = {}, summary } = { ...data }
            if (!success) {
                throw new Error(mess)
            }

            const showTabKeys = Object.keys(show_tabs).length > 0 ? Object.keys(show_tabs) : []
            const showTabsArray = showTabKeys.map(item => {
                // Tách các từ bằng dấu "_" và viết hoa
                const formattedLabel = item.split('_').map(word => word.toUpperCase()).join(' ')
                return { value: item, label: formattedLabel }
            })

            this.setState({
                listTab: showTabsArray,
                summary: summary,
                data: data,
            })
        } catch (error) {
            message.error(error.message)
            this.setState({ error: error.message })
        } finally {
            this.setState({ loading: false })
        }
    }

    // @deprecated
    _fetchStaticsCreated = async () => {
        const { partner } = this.state
        this.setState({
            loading: true,
            error: '',
            data: [],
        })

        const payload = {
            cutoff_date: this.state.cutoffDate ? this.state.cutoffDate.format('DD/MM/YYYY') : ''
            // include_is_archived: true,
            // subtract_days: 100,
        }

        if (partner) {
            payload.partner = partner
        } else {
            delete payload.partner
        }

        try {
            const { data: response } = await statisticCutoff(payload)

            const { success, data, message: mess } = response || {}

            if (!success) {
                throw new Error(mess)
            }

            this.setState({
                loading: false,
                data: data
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        } finally {
            this.setState({ loading: false })
        }
    }

    _onChange = (dates) => {
        this.setState({
            cutoffDate: dates
        })
    }

    _onClickButton = () => {
        this._fetchStaticsCreated()
    }

    _handleExport = async () => {
        const { partner, currentTab, order_type, silkFilter, embroideryFilter, exporting } = this.state

        if (exporting) return

        const params = {
            ...(partner && { partner }),
            ...(order_type && { order_type }),
        }

        if (currentTab) params.cutoff_type = currentTab
        if (silkFilter) params.is_silk_or_pyjama = silkFilter
        if (embroideryFilter) params.is_embroidery = embroideryFilter

        try {

            await runExportJob(
                EXPORT_KEY,
                () => exportCutoffV2(params),
                { filename: `Statics-Cutoff-${moment().format('YYYY-MM-DD')}.csv` }
            )

        } catch (e) {
            // `runExportJob` tự báo lỗi (toast hoặc Modal) và KHÔNG reject, nên nhánh này chỉ
            // còn là lưới an toàn cho lỗi phát sinh trước lời gọi. Cố ý KHÔNG set `state.error`:
            // khung đó là chỗ báo lỗi của BẢNG cutoff (`StaticsTableCutoff`), lỗi export hiện ở
            // đó sẽ dính lại tới lần fetch bảng kế tiếp mới được xoá.
            message.error(e.message)
        }
    }

    _handleFilterCheckbox = (checked, field) => {
        this.setState({
            [field]: checked
        })
    }

    _handleChangePartner = (value) => {
        const [p, v] = `${value}`.split(':')
        const prop = p && v ? p : 'partner'
        const val = p && v ? v : value

        this.setState({
            ...(
                p && v
                    ? {
                        [prop]: val,
                        partner: ''
                    }
                    : {
                        [prop]: val,
                        order_type: ''
                    }
            )
        }, () => {
            // this._fetchStaticsCreated()
            this._fetchStatisticCutoff()
        })
    }

    onChangeCutoffReportType = (e) => {
        localStorage.setItem('cutoff_current_tab', e.target.value)
        this.setState({
            currentTab: e.target.value
        }, () => {
            this._fetchStatisticCutoff()
        })
    }

    totalCutoffNotCompletedContent = (updateDesign, hasNote, noNote) => {
        return (
            <div className='totalCutoffNotCompletedContent'>
                {!!noNote && <div className='noNote'><span className="font-weight-bold">No note:</span> {noNote}</div>}
                {!!hasNote && <div className='hasNote'><span className="font-weight-bold">Has note:</span> {hasNote}</div>}
                {!!updateDesign && <div className='updateDesign'><span className="font-weight-bold">Update design:</span> {updateDesign}</div>}
            </div>
        )
    }

    _handleSortData = (key, desc) => {
        const { data, sortData } = this.state
        const { items = [] } = data

        if (items !== undefined && items.length > 0) {
            this.setState({
                sortData: {
                    ...sortData,
                    sort: key,
                    desc: desc
                }
            })
        }
    }

    render() {
        const { data, loading, error, exporting, partner, currentTab, listTab, summary, order_type, silkFilter, embroideryFilter, sortData } = this.state
        const { last_shipping_date = {} } = { ...data }
        const { total: cutoffTotal = 0, completed: cutoffCompletedTotal = 0, not_completed: cutoffNotCompletedTotal = 0, not_pushed: cutoffNotPushedTotal = 0, not_completed_due_to_update_design = 0, not_completed_has_note = 0, not_completed_no_note = 0 } = { ...summary }
        const percentCutoffCompleted = (cutoffCompletedTotal / cutoffTotal) * 100
        const percentCutoffNotCompleted = (cutoffNotCompletedTotal / cutoffTotal) * 100
        const percentCutoffNotPush = (cutoffNotPushedTotal / cutoffTotal) * 100
        const selectedValue = order_type ? `order_type:${order_type}` : partner

        return (
            <Row className='text-center'>
                <Col md={12}>
                    <div className="StaticsCutoffPage StaticsCreatedPage">
                        <Card>
                            <CardHeader className="CardHeader text-white header-elements-inline">
                                <div className="d-flex flex-wrap">
                                    <h2 className="card-title d-flex align-items-center">
                                        <IconHead2 />
                                        <span className='mr-5'>Thống kê sản lượng CUTOFF</span>
                                    </h2>
                                    <Radio.Group
                                        value={currentTab}
                                        onChange={this.onChangeCutoffReportType}
                                    >
                                        <Radio.Button className='optionCutoffReport' value=''>CUTOFF</Radio.Button>
                                        {listTab && listTab.length > 0 &&
                                            listTab.map((i, idx) => (
                                                <Radio.Button key={`optionCutoffReport_${idx}`} className='optionCutoffReport' value={i.value}>{i.label}</Radio.Button>
                                            ))
                                        }
                                    </Radio.Group>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <div className="SearchDateTime d-flex align-items-center justify-content-between">
                                    <div className="listTotalStatisticCutoff d-flex align-items-center">
                                        <div className="statisticCutoffItem">
                                            <Spin spinning={loading} indicator={<React.Fragment />}>
                                                <div className="totalCutoff">
                                                    <span>Tổng Cutoff</span>
                                                    <h1 className='mb-0'>
                                                        {cutoffTotal.toLocaleString("vi-VN")}
                                                    </h1>
                                                </div>
                                            </Spin>
                                        </div>
                                        <div className="statisticCutoffItem">
                                            <Spin spinning={loading} indicator={<React.Fragment />}>
                                                <div className="totalCutoffCompleted">
                                                    <span>Tổng Cutoff đã Hoàn thành</span>
                                                    <h1 className='mb-0'>
                                                        {cutoffCompletedTotal.toLocaleString("vi-VN")}
                                                        {!!cutoffTotal &&
                                                            <small className='percent mx-1'>{`(${percentCutoffCompleted % 1 === 0 ? percentCutoffCompleted : percentCutoffCompleted.toFixed(2)}%)`}</small>
                                                        }
                                                    </h1>
                                                </div>
                                            </Spin>
                                        </div>
                                        <div className="statisticCutoffItem">
                                            <Spin spinning={loading} indicator={<React.Fragment />}>
                                                <div className="totalCutoffNotCompleted">
                                                    {(!!not_completed_due_to_update_design || !!not_completed_has_note || !!not_completed_no_note) ?
                                                        <Popover
                                                            className='d-flex flex-column align-items-center justify-content-between cutoffNotCompletedTotalPopover'
                                                            content={this.totalCutoffNotCompletedContent(not_completed_due_to_update_design, not_completed_has_note, not_completed_no_note)}
                                                        >
                                                            <span>Tổng Cutoff chưa Hoàn thành</span>
                                                            <h1 className='mb-0'>{cutoffNotCompletedTotal.toLocaleString("vi-VN")}
                                                                {!!cutoffTotal &&
                                                                    <small className='percent mx-1'>{`(${percentCutoffNotCompleted % 1 === 0 ? percentCutoffNotCompleted : percentCutoffNotCompleted.toFixed(2)}%)`}</small>
                                                                }
                                                            </h1>
                                                        </Popover> :
                                                        <>
                                                            <span>Tổng Cutoff chưa Hoàn thành</span>
                                                            <h1 className='mb-0'>{cutoffNotCompletedTotal.toLocaleString("vi-VN")}
                                                                {!!cutoffTotal &&
                                                                    <small className='percent mx-1'>{`(${percentCutoffNotCompleted % 1 === 0 ? percentCutoffNotCompleted : percentCutoffNotCompleted.toFixed(2)}%)`}</small>
                                                                }
                                                            </h1>
                                                        </>
                                                    }
                                                </div>
                                            </Spin>
                                        </div>
                                        <div className="statisticCutoffItem">
                                            <Spin spinning={loading} indicator={<React.Fragment />}>
                                                <div className="totalCutoffNotPushFACYet">
                                                    <span>Tổng Cutoff chưa push FAC</span>
                                                    <h1 className='mb-0'>{cutoffNotPushedTotal.toLocaleString("vi-VN")}
                                                        {!!cutoffTotal &&
                                                            <small className='percent mx-1'>{`(${percentCutoffNotPush % 1 === 0 ? percentCutoffNotPush : percentCutoffNotPush.toFixed(2)}%)`}</small>
                                                        }
                                                    </h1>
                                                </div>
                                            </Spin>
                                        </div>
                                        {/* <span>Ngày Cutoff</span>
                                        <div className='DatePicker ml-2'>
                                            <DatePicker
                                                value={cutoffDate}
                                                format="DD/MM/YYYY"
                                                onChange={this._onChange}
                                            />
                                        </div>
                                        <div className="">
                                            <button className='ml-3 btn btn-primary' disabled={!cutoffDate} onClick={this._onClickButton}>Thống kê</button>
                                        </div> */}
                                    </div>
                                    <div className="rightInfo float-right">
                                        <div className='d-flex flex-nowrap justify-content-end'>
                                            <div className="FilterVip d-flex align-items-center pr-2 mr-2 border-right FilterPartner">
                                                <Select
                                                    style={{ width: 120 }}
                                                    onChange={this._handleChangePartner}
                                                    options={[
                                                        { value: '', label: 'All' },
                                                        // { value: 'BINHMINH', label: 'Bình Minh' },
                                                        // { value: 'QUANGMINH', label: 'Quang Minh' },
                                                        // { value: 'TOANCAU', label: 'Toàn Cầu' },
                                                        { value: 'vip', label: 'VIP' },
                                                        { value: 'novip', label: 'NOT VIP' },
                                                        { value: 'order_type:TikTok', label: 'TikTok' },
                                                    ]}
                                                    value={selectedValue || ''}
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="FilterVip d-flex align-items-center pr-2 mr-2 border-right FilterPartner">
                                                <Checkbox
                                                    checked={embroideryFilter}
                                                    onChange={e => this._handleFilterCheckbox(e.target.checked, 'embroideryFilter')}
                                                    disabled={loading}
                                                >
                                                    SP Thêu
                                                </Checkbox>
                                            </div>
                                            <div className="FilterVip d-flex align-items-center pr-2 mr-2 border-right FilterPartner">
                                                <Checkbox
                                                    checked={silkFilter}
                                                    onChange={e => this._handleFilterCheckbox(e.target.checked, 'silkFilter')}
                                                    disabled={loading}
                                                >
                                                    Hàng lụa
                                                </Checkbox>
                                            </div>
                                            <div className="Export d-flex align-items-center">
                                                {/* <h6 className='mr-3 mb-0'>Tổng: <span className='font-weight-bold mr-0'>{data.total_orders || 0}</span> đơn hàng </h6> */}
                                                <button
                                                    type="default"
                                                    className='btn btn-primary'
                                                    onClick={this._handleExport}
                                                    disabled={loading || exporting}
                                                >
                                                    {exporting && <i className="fa fa-spinner fa-spin mr-1" />}
                                                    {exporting ? 'Exporting' : 'Export'}
                                                </button>
                                            </div>
                                        </div>
                                        {last_shipping_date.shipping_date &&
                                            <h4 className='lastShippingDate font-weight-bold mt-3 mb-0' style={{ color: '#cf2438' }}>
                                                {`Thời gian ship chuyến cuối: ${moment(last_shipping_date.shipping_date).utc().format(`HH:mm DD/MM/YYYY`)} `}
                                            </h4>
                                        }
                                    </div>
                                </div>
                                <Spin spinning={loading} tip='Loading data...' >
                                    <div className="TableStatics d-flex justify-content-between">
                                        <StaticsTableCutoff 
                                            data={!!data ? data : []} 
                                            loading={loading} 
                                            error={error} 
                                            silkFilter={silkFilter}
                                            embroideryFilter={embroideryFilter}
                                            sortData={sortData}
                                            onSortData={this._handleSortData}
                                        />
                                    </div>
                                </Spin>
                            </CardBody>
                        </Card>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default StaticsCutoffPage
